import { Button } from "./Button";
import { setScreen, setShowRules } from "../app/slices/appSlice";
import { screens } from "../app/data/app";
import { useAppDispatch } from "../app/hooks";
import { ReactElement } from "react";
import { giEvent } from "../app/utils/metrix";


export const Rules = (): ReactElement => {
  const dispatch = useAppDispatch()

  const next = () => {
    giEvent('START_anketa')
    dispatch(setScreen(screens.AUTH))
  }

  return (
    <div className={'rules rel'}>
      <div className={'pb_rules bubble bubble_purple bubble_bottom'}>
        <h1 className={'headline font_beige'}>Правила</h1>
        <p className={'font_white'}>
          Выжимай цены с помощью <br/> кнопки на экране. Набирай клики <br/> и обменивай их на промокоды <br/> от Мегамаркета. <br/>
          <span className={'link font_green'} onClick={() => dispatch(setShowRules(true))}>ПОДРОБНЕЕ</span>
        </p>
        <div className={'rules__gears'}/>
      </div>
      <div className={'rules__machine-wrap'}>
        <div className={'rules__machine'}></div>
      </div>
      <Button cssClass={'button_rules button_green'} clickEvent={() => next()}>Начать</Button>
    </div>
  )
}

